import { z } from 'zod';
import { muteKind } from './i18n.js';

export const muteDto = z.object({
  id: z.uuid(),
  keyword: z.string(),
});
export type MuteDto = z.infer<typeof muteDto>;

export const createMuteBody = z.object({
  keyword: z.string().min(2).max(100),
  // 'tag' = the keyword came from an AI tag chip (premium); 'word' = free keyword mute
  kind: muteKind.default('word'),
});

export const pushSubscribeBody = z.object({
  endpoint: z.url(),
  keys: z.object({
    p256dh: z.string(),
    auth: z.string(),
  }),
});
export type PushSubscribeBody = z.infer<typeof pushSubscribeBody>;

export const pushUnsubscribeBody = z.object({
  endpoint: z.url(),
});

export const searchQuery = z.object({
  q: z.string().min(1).max(200),
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(100).default(50),
});
export type SearchQuery = z.infer<typeof searchQuery>;

export const packLanguage = z.enum(['cs', 'en']);
export type PackLanguage = z.infer<typeof packLanguage>;

// starter-packs.json: name per UI language; `lang` is the language of the sources so the
// onboarding can show the user's own language first and the rest under "international"
export const starterPack = z.object({
  id: z.string(),
  name: z.record(packLanguage, z.string()),
  emoji: z.string(),
  lang: packLanguage,
  feeds: z.array(z.object({ url: z.string(), title: z.string() })),
});
export type StarterPack = z.infer<typeof starterPack>;

export const deleteAccountBody = z.object({
  password: z.string().min(1),
});

export const healthResponse = z.object({
  status: z.enum(['ok', 'degraded']),
  dbOk: z.boolean(),
  lastFetchRunAt: z.string().nullable(),
  lastFetchOk: z.boolean().nullable(),
});
export type HealthResponse = z.infer<typeof healthResponse>;

export const weeklyStats = z.object({
  readCount: z.number().int(),
  savedCount: z.number().int(),
  minutesSavedEstimate: z.number().int(),
});
export type WeeklyStats = z.infer<typeof weeklyStats>;
